import {
  uploadAttachmentBlob,
  uploadAttachmentMeta,
  uploadAttachmentRefresh,
} from '../thunks/marketplace-attachment-upload';

export const marketplaceAttachmentUploadReducers = (builder) => {
  // Upload file metadata
  builder.addCase(uploadAttachmentMeta.fulfilled, (state, action) => {
    const attachment = action.payload.data || {};
    const importedAttachments = [...state.importedAttachments];
    importedAttachments.push({ ...attachment, status: 'pending' });
    state.importedAttachments = importedAttachments;
  });

  // Upload file blob
  builder.addCase(uploadAttachmentBlob.rejected, (state, action) => {
    const attachmentId = action.payload;
    const importedAttachments = [...state.importedAttachments];
    const attachmentIndex = importedAttachments.findIndex((item) => item.id === attachmentId);
    if (attachmentIndex !== -1) {
      importedAttachments[attachmentIndex] = {
        ...importedAttachments[attachmentIndex],
        status: 'rejected',
      };
      state.importedAttachments = importedAttachments;
    }
  });
  builder.addCase(uploadAttachmentBlob.fulfilled, (state, action) => {
    const attachmentId = action.payload.id;
    const importedAttachments = [...state.importedAttachments];
    const attachmentIndex = importedAttachments.findIndex((item) => item.id === attachmentId);
    if (attachmentIndex !== -1) {
      importedAttachments[attachmentIndex] = {
        ...importedAttachments[attachmentIndex],
        status: 'fulfilled',
      };
      state.importedAttachments = importedAttachments;
    }
  });

  // Upload file refresh
  builder.addCase(uploadAttachmentRefresh.fulfilled, (state, action) => {
    const attachmentId = action.payload.id;
    const importedAttachments = [...state.importedAttachments];
    const attachmentIndex = importedAttachments.findIndex((item) => item.id === attachmentId);
    if (attachmentIndex !== -1) {
      importedAttachments[attachmentIndex] = {
        ...importedAttachments[attachmentIndex],
        status: 'fulfilled',
      };
      state.importedAttachments = importedAttachments;
    }
  });
};
